import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { SelectCycleDisclaimer } from './SelectCycleDisclaimer';
import { SelectPlanDisclaimer } from './SelectPlanDisclaimer';
export const StepDisclaimer = () => {
  const module = useCurrentModule();
  const currentStep = module.internals.hooks.useCurrentStep();
  if (currentStep === 'select-plan') {
    return /*#__PURE__*/React.createElement(SelectPlanDisclaimer, null);
  }
  if (currentStep === 'select-cycle') {
    return /*#__PURE__*/React.createElement(SelectCycleDisclaimer, null);
  }
  if (currentStep === 'checkout') {
    return null;
  }
  return null;
};
//# sourceMappingURL=StepDisclaimer.js.map